<template>
  <b-row>
    <b-col md="3" class="mb-3">
      <!-- @input="adicionarValorTotal" -->
      <input-number-value
        ref="valorBruto"
        v-model="form.valorBruto"
        :label="$t(`SUPRIMENTOS_LANCAMENTOS_NF.VALOR_BRUTO`)"
        required
        type="number"
        :min="0"
        :key="keyAtualizaValorBruto"
        @input="alterarBotaoParaRecalcular"
      />
    </b-col>
    <b-col md="3" class="mb-3">
      <!-- @input="removerValorTotal" -->
      <input-number-value
        ref="descontos"
        v-model="form.descontos"
        :label="$t(`SUPRIMENTOS_LANCAMENTOS_NF.VALOR_DESCONTOS`)"
        decimal
        type="number"
        :min="0"
        :max="this.form.valorTotal"
        @input="alterarBotaoParaRecalcular"
      />
    </b-col>
    <b-col md="6" class="mb-3">
      <input-btn
        v-model="valorTotalImpostos"
        :label="$t(`SUPRIMENTOS_LANCAMENTOS_NF.VALOR_IMPOSTOS`)"
        placeholder="SUPRIMENTOS_LANCAMENTOS_NF.VALOR_IMPOSTOS"
        btnAppend="SUPRIMENTOS_LANCAMENTOS_NF.VISUALIZAR"
        readonly
        @btn-emit="irParaTab(2)"
        @change="alterarBotaoParaRecalcular"
      />
    </b-col>
    <b-col md="4" class="mb-3">
      <input-number-value
        ref="valorTotal"
        v-model="form.valorTotal"
        :label="$t(`SUPRIMENTOS_LANCAMENTOS_NF.VALOR_TOTAL_DA_NOTA_FISCAL`)"
        placeholder="SUPRIMENTOS_LANCAMENTOS_NF.VALOR_TOTAL_DA_NOTA_FISCAL"
        required
        type="number"
        :min="0"
        decimal
        @input="alterarBotaoParaRecalcular"
      />
    </b-col>
    <b-col md="8">
      <input-select-multiple
        ref="historicoLancamento"
        v-model="form.historicoLancamento"
        :label="$t('FINANCEIRO.HISTORICO_LANCAMENTO')"
        :options="opcoes.historicoLancamento"
        class="mb-3"
        @change="alterarBotaoParaRecalcular"
        required
      />
    </b-col>
    <b-col md="2" class="mb-3">
      <input-select-multiple
        ref="formaPagamento"
        v-model="form.formaPagamento"
        :value="form.formaPagamento"
        :label="$t('FINANCEIRO.FORMA_PAGAMENTO')"
        :options="opcoes.formaPagamento"
        @input="alterarBotaoParaRecalcular"
        required
      />
    </b-col>
    <b-col
      md="2"
      v-if="form.formaPagamento && form.formaPagamento.value == 'Parcelado'"
    >
      <input-number
        ref="numeroParcelas"
        v-model="form.numeroParcelas"
        :label="$t(`SUPRIMENTOS_LANCAMENTOS_NF.NUMERO_PARCELAS`)"
        placeholder="SUPRIMENTOS_LANCAMENTOS_NF.NUMERO_PARCELAS"
        min="2"
        decimal
        @change="alterarBotaoParaRecalcular"
        required
      />
    </b-col>
    <b-col md="4">
      <b-button
        class="botao-acao-filtro w-100 mb-3"
        variant="primary"
        @click="calcularParcelas"
      >
        {{ textoBtn }}
      </b-button>
    </b-col>
  </b-row>
</template>
<script>
// Utils & Aux:
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import helpers from '@/common/utils/helpers';

// Services:
import EnumeradoresService from '@/common/services/enumeradores/enumeradores.service.js';
import HistoricoLancamentoService from '@/common/services/historico-lancamento/historico-lancamento.service.js';

// Components:
import {
  InputBtn,
  InputNumber,
  InputNumberValue,
  InputSelectMultiple,
} from '@/components/inputs';

export default {
  props: {
    form: { type: Object, default: Object },
    valorTotalImpostos: { type: String, default: String },
    keyAtualizaValorBruto: { type: Number, default: 1 },
  },
  components: {
    InputBtn,
    InputNumberValue,
    InputNumber,
    InputSelectMultiple,
  },
  mounted() {
    this.getHistoricosLancamento();
    this.getFormaPagamento();
    this.inicializarValoresAnteriores();
  },
  data() {
    return {
      opcoes: {
        historicoLancamento: [],
        formaPagamento: [],
      },
      textoBtn: 'Calcular valor para pagamento',
      formaPagamento: null,
      valoresAnteriores: null, 
    };
  },
  watch: {
    form: {
      handler() {
        this.inicializarValoresAnteriores();
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    limparParcelas() {
      this.$emit('limpar-parcelas');
    },
    getFormaPagamento() {
      this.$store.dispatch(START_LOADING);
      EnumeradoresService.listar('forma-pagamento-nf')
        .then(({ data }) => {
          data = data.map((row) => ({
            value: row.id,
            text: row.descricao,
          }));
          this.opcoes.formaPagamento = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    getHistoricosLancamento() {
      this.$store.dispatch(START_LOADING);
      HistoricoLancamentoService.obterEnumContasPagar()
        .then(({ data }) => {
          this.opcoes.historicoLancamento = data;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    calcularParcelas() {
      if (!this.validarFormulario()) return;

      if (this.form.formaPagamento?.value == 'AVista') {
        this.form.numeroParcelas = 1;
      }
      let parcelasGeradas = [];

      let valorParcela = this.form.valorTotal / this.form.numeroParcelas;

      for (let i = 0; i < this.form.numeroParcelas; i++) {
        const [anoStr, mesStr, diaStr] = this.form.dataVencimento.split('-');
        
        const anoOriginal = parseInt(anoStr);
        const mesOriginal = parseInt(mesStr) - 1; 
        const diaOriginal = parseInt(diaStr);
        
        const novoMes = mesOriginal + i;
        const novoAno = anoOriginal + Math.floor(novoMes / 12);
        const mesFinal = novoMes % 12;
        
        const ultimoDiaDoMes = new Date(novoAno, mesFinal + 1, 0).getDate();
        const diaFinal = Math.min(diaOriginal, ultimoDiaDoMes);
        
        const ano = novoAno;
        const mes = String(mesFinal + 1).padStart(2, '0'); 
        const dia = String(diaFinal).padStart(2, '0');
        let dataParcelaString = `${ano}-${mes}-${dia}`;
        
        parcelasGeradas.push({
          dataLancamento: this.form.dataEmissao,
          dataVencimento: dataParcelaString,
          valorDocumento: Number(valorParcela.toFixed(2)),
        });
      }

      let valorDiferencaValorParcelasValorTotal = 0;
      let calculoValidacaoValorParcelas = 0;

      parcelasGeradas.forEach((item) => {
        calculoValidacaoValorParcelas += Number(item.valorDocumento);
      });

      if (calculoValidacaoValorParcelas !== this.form.valorTotal) {
        valorDiferencaValorParcelasValorTotal =
          this.form.valorTotal - calculoValidacaoValorParcelas;
      }

      if (valorDiferencaValorParcelasValorTotal) {
        parcelasGeradas[parcelasGeradas.length - 1].valorDocumento =
          Number(parcelasGeradas[parcelasGeradas.length - 1].valorDocumento) +
          valorDiferencaValorParcelasValorTotal;
      }

      this.$emit('capturar-parcelas', parcelasGeradas);
    },
    alterarBotaoParaRecalcular() {
      const valoresAtuais = {
        valorBruto: this.form.valorBruto,
        descontos: this.form.descontos,
        valorTotal: this.form.valorTotal,
        historicoLancamento: this.form.historicoLancamento,
        formaPagamento: this.form.formaPagamento,
        numeroParcelas: this.form.numeroParcelas
      };
      
      if (!this.valoresAnteriores) {
        this.valoresAnteriores = valoresAtuais;
        return;
      }
      
      const houveMudanca = Object.keys(valoresAtuais).some(key => {
        const valorAtual = valoresAtuais[key];
        const valorAnterior = this.valoresAnteriores[key];
        
        if (typeof valorAtual === 'object' && typeof valorAnterior === 'object') {
          return JSON.stringify(valorAtual) !== JSON.stringify(valorAnterior);
        }
        return valorAtual !== valorAnterior;
      });
      
      if (houveMudanca) {
        const parcelasExistentes = this.form.notasFiscaisParcelas || [];
        const parcelasSaoValidas = this.validarParcelasExistentes(parcelasExistentes, valoresAtuais);
        
        if (!parcelasSaoValidas) {
          this.limparParcelas();
          this.$emit('capturar-parcelas', []);
        }
        
        this.valoresAnteriores = valoresAtuais;
      }
    },
    irParaTab(tab) {
      this.$emit('alterar-tab', tab);
    },
    armazenarSelecionado(key, item) {
      this.form[`${key}Id`] = item.id;
    },
    validarFormulario() {
      return helpers.validarFormulario(this.$refs);
    },
    inicializarValoresAnteriores() {
      this.valoresAnteriores = {
        valorBruto: this.form.valorBruto,
        descontos: this.form.descontos,
        valorTotal: this.form.valorTotal,
        historicoLancamento: this.form.historicoLancamento,
        formaPagamento: this.form.formaPagamento,
        numeroParcelas: this.form.numeroParcelas
      };
    },
    validarParcelasExistentes(parcelasExistentes, valoresAtuais) {
      if (!parcelasExistentes || parcelasExistentes.length === 0) {
        return false;
      }
      
      if (valoresAtuais.valorTotal !== this.valoresAnteriores.valorTotal) {
        return false;
      }
      
      const formaPagamentoAnterior = this.valoresAnteriores.formaPagamento?.value;
      const formaPagamentoAtual = valoresAtuais.formaPagamento?.value;
      
      if (formaPagamentoAnterior !== formaPagamentoAtual) {
        if (formaPagamentoAnterior === 'AVista' && formaPagamentoAtual === 'Parcelado') {
          return parcelasExistentes.length === 1 && 
                 parcelasExistentes[0].valorDocumento === valoresAtuais.valorTotal;
        }
        else if (formaPagamentoAnterior === 'Parcelado' && formaPagamentoAtual === 'AVista') {
          return parcelasExistentes.length === 1;
        }
        else {
          return false;
        }
      }
      
      if (valoresAtuais.numeroParcelas !== this.valoresAnteriores.numeroParcelas) {
        return parcelasExistentes.length === valoresAtuais.numeroParcelas;
      }
      
      return true;
    }
  },
};
</script>
